import { render } from "./Indicator.vue?vue&type=template&id=0380a41c&scoped=true&ts=true"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"

import "./Indicator.vue?vue&type=style&index=0&id=0380a41c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0380a41c"]])

export default __exports__